// extracted by mini-css-extract-plugin
module.exports = {"itemListSection":"ItemListSection_itemListSection__KGB62","title":"ItemListSection_title__2dC3x","list":"ItemListSection_list__1WZWy"};